module.exports = __webpack_public_path__ + "static/media/Medical_pathology_SDK@2x.320289bd.png";